import type { AiCostLimitPayload } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetched';

export type AiCostLimitUpdatedAction = {
	type: 'AI_COST_LIMIT_UPDATED';
	payload: AiCostLimitPayload;
	accountId: number;
};

export default (payload: AiCostLimitPayload, accountId: number): AiCostLimitUpdatedAction => ({
	type: 'AI_COST_LIMIT_UPDATED',
	payload,
	accountId,
});
